// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import ButtonRegular from '/react4xp/components/ButtonRegular'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface SponsorshipsProps {
    bgColor: 'default' | 'green' | 'beige'
    img?: {
        src: string
        alt: string
    }
    subTitle?: string
    title?: string
    text?: string
    cta?: {
        label: string
        href: string
        isExternal?: boolean
    }
}

export default function Sponsorships({
    bgColor,
    img,
    subTitle,
    title,
    text,
    cta
}: SponsorshipsProps) {
    return (
        <Section
            bgColor={clsx(
                bgColor === 'beige' && 'bg-beige-primary-dark',
                bgColor === 'green' && 'bg-green-secondary-dark'
            )}
            textColor='text-dark'
            className='sponsorships'
        >
            <div className='grid-container'>
                <div className='sponsorships__wrapper'>
                    <div className='grid-row'>

                        <div className='c-md-1 hide-md'></div>

                        <div className='c-md-5'>
                            <div className={clsx(
                                'sponsorships__image',
                                !img?.src && 'sponsorships__image--no-image'
                            )}>
                                {isNonWhitespaceString(img?.src) && (
                                    <Image
                                        src={img.src}
                                        alt={img.alt}
                                        lazyLoad
                                    />
                                )}
                            </div>
                        </div>

                        <div className='c-lg-1 hide-lg'></div>

                        <div className='c-md-5 c-lg-4'>
                            <div className='sponsorships__content'>

                                {isNonWhitespaceString(subTitle) && (
                                    <h4 className='sponsorships__sub-title text-lg'>
                                        {subTitle}
                                    </h4>
                                )}

                                {isNonWhitespaceString(title) && (
                                    <h2 className='sponsorships__title title-sm'>
                                        {title}
                                    </h2>
                                )}

                                {isNonWhitespaceString(text) && (
                                    <div
                                        className='sponsorships__text text-md'
                                        dangerouslySetInnerHTML={{ __html: text }}
                                        suppressHydrationWarning
                                    />
                                )}

                                {isNonWhitespaceString(cta) && (
                                    <ButtonRegular
                                        text={cta.label}
                                        href={cta.href}
                                        target={cta.isExternal}
                                        className='sponsorships__cta'
                                        icon={{
                                            svg: "<svg width='14' height='12' viewBox='0 0 14 12' xmlns='http://www.w3.org/2000/svg'><path d='M7.9998 0.510254L13.4898 6.0002L7.9998 11.4902L7.00985 10.5002L10.8099 6.7002H0.799805V5.3002H10.8099L7.00985 1.5002L7.9998 0.510254Z'/></svg>",
                                            position: 'right'
                                        }}
                                    />
                                )}

                            </div>
                        </div>

                        <div className='c-md-1 hide-md'></div>

                    </div>
                </div>
            </div>
        </Section>
    )
}